import { makeStyles } from '@material-ui/core/styles'
import { colors } from '../../variables.style'

const fontFamily = '"Barlow", san-serif'

// Style names here must match rule names here: https://material-ui.com/api/slider/#css
export const style = {
  root: {
    color: colors.metallicSeaweed,
    marginTop: 5
  },
  valueLabel: {
    fontFamily,
    fontSize: 10,
    textAlign: 'center'
  },
  markLabel: {
    fontFamily,
    fontSize: 12
  },
  marked: {
    marginBottom: 12
  }
}

// Material UI has it's own JSS wrapper to override their styles
export const useStyles = makeStyles(style)
